import { render, staticRenderFns } from "./buttonSwitching.vue?vue&type=template&id=0e0d7f8f&scoped=true"
import script from "./buttonSwitching.vue?vue&type=script&lang=js"
export * from "./buttonSwitching.vue?vue&type=script&lang=js"
import style0 from "./buttonSwitching.vue?vue&type=style&index=0&id=0e0d7f8f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e0d7f8f",
  null
  
)

export default component.exports